import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { COMPANY_SUGGESTIONS_API } from '../../utils/api'; // ✅ Make sure this is defined

function CompanyInfoTab({ form, setForm, handleChange }) {
  const [companyOptions, setCompanyOptions] = useState([]);
  const token = localStorage.getItem('token');
  const customer_id = JSON.parse(atob(token)).customer_id;
  const inputValueRef = useRef('');

  useEffect(() => {
    fetchCompanySuggestions();
  }, []);

  const fetchCompanySuggestions = async () => {
    try {
      const res = await axios.post(COMPANY_SUGGESTIONS_API, {
        customer_id,
        token
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        const formatted = res.data.companies.map((item) => ({
           label: `${item.company.trim()} (${item.company_address.trim()}, ${item.city.trim()})`,
          value: item.company.trim(),
          ...item
        }));
        setCompanyOptions(formatted);
      }
    } catch (err) {
      console.error('Failed to load companies:', err);
    }
  };

  const handleCompanySelect = (selectedOption) => {
    if (selectedOption) {
      setForm((prev) => ({
        ...prev,
        company: selectedOption.value,
        companyAddress: selectedOption.company_address || '',
        pincode: selectedOption.pincode || '',
        state: selectedOption.state || '',
        district: selectedOption.district || '',
        city: selectedOption.city || ''
      }));
    } else {
      // Clear everything
      setForm((prev) => ({
        ...prev,
        company: '',
        companyAddress: '',
        pincode: '',
        state: '',
        district: '',
        city: ''
      }));
    }
  };

  const handlePincodeBlur = async () => {
    const pincode = form.pincode?.trim();
    if (!pincode || pincode.length !== 6) return;

    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await res.json();

      if (
        Array.isArray(data) &&
        data[0].Status === 'Success' &&
        Array.isArray(data[0].PostOffice) &&
        data[0].PostOffice.length > 0
      ) {
        const loc = data[0].PostOffice[0];
        setForm((prev) => ({
          ...prev,
          city: loc.Name || '',
          district: loc.District || '',
          state: loc.State || ''
        }));
      } else {
        alert('Invalid PIN Code or no Post Office found.');
      }
    } catch (err) {
      console.error('❌ Fetch error:', err);
      alert('Error fetching location details.');
    }
  };

  return (
    <div className="row g-3">
      <div className="col-md-4">
        <label className="form-label">Company Name</label>
        <Select
  options={companyOptions}
  onChange={(selectedOption) => {
    if (selectedOption) {
      handleCompanySelect(selectedOption);
    } else {
      // If cleared
      setForm((prev) => ({
        ...prev,
        company: '',
        companyAddress: '',
        pincode: '',
        state: '',
        district: '',
        city: ''
      }));
    }
  }}
  onInputChange={(inputValue) => {
    inputValueRef.current = inputValue; // 👈 track typed text
  }}
  onBlur={() => {
    if (!form.company && inputValueRef.current.trim()) {
      // 👇 Manually set the typed value if no selection was made
      setForm((prev) => ({
        ...prev,
        company: inputValueRef.current.trim()
      }));
    }
  }}
  isClearable
  isSearchable
  placeholder="Select or type company name"
  value={
    form.company
      ? { label: form.company, value: form.company }
      : null
  }
        />
      </div>

      <div className="col-md-8">
        <label className="form-label">Company Address</label>
        <input
          className="form-control"
          name="companyAddress"
          value={form.companyAddress}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Pincode</label>
        <input
          className="form-control"
          name="pincode"
          value={form.pincode}
          onChange={handleChange}
          onBlur={handlePincodeBlur}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">State</label>
        <input
          className="form-control"
          name="state"
          value={form.state}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">District</label>
        <input
          className="form-control"
          name="district"
          value={form.district}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">City</label>
        <input
          className="form-control"
          name="city"
          value={form.city}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default CompanyInfoTab;
